import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { showToast } from "../../store/actions";

import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import Backdrop from "@mui/material/Backdrop";
import InputLabel from "@mui/material/InputLabel";
import Grid from "@mui/material/Grid";

import makeStyles from "@mui/styles/makeStyles";
import createStyles from "@mui/styles/createStyles";

import UserService from "../../service/user";
import JobService from "../../service/job";

const useStyles = makeStyles((theme) =>
  createStyles({
    paper: {
      height: "100%",
      padding: "10px 20px",
    },
    detailsHeader: {
      fontWeight: "normal",
      "&::after": {
        content: "''",
        display: "block",
        width: "40px",
        height: "3px",
        background: "#EC5143",
        margin: "5px 0 0",
        borderRadius: "5px",
      },
    },
  })
);

const AssignJob = ({ job_id, defaultEmployee, defaultEmployeeDescription, setStatus, setValue, readOnly = false }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [employees, setEmployees] = useState([]);
  const [employee, setEmployee] = useState(defaultEmployee);
  const [employeeDescription, setEmployeeDescription] = useState(defaultEmployeeDescription);

  const [loading, setLoading] = useState(true);
  const [updateLoading, setUpdateLoading] = useState(false);

  const [errors, setErrors] = useState({
    employeeId: false,
    description: false,
  });

  useEffect(() => {
    const User = new UserService();

    User.getEmployees().then((response) => {
      if (response.success && response.data?.userList?.length) {
        setEmployees(response.data.userList);
      }

      setLoading(false);
    });
  }, []);

  const handleAssignJob = () => {
    setErrors((prevState) => {
      return {
        ...prevState,
        employeeId: employee === "",
        description: employeeDescription.trim() === "" || employeeDescription.trim().length > 500,
      };
    });

    if (!(employee === "" || employeeDescription.trim() === "" || employeeDescription.trim().length > 500)) {
      setUpdateLoading(true);
      const Job = new JobService();

      const formData = new FormData();
      formData.append("Employee_id", employee);
      formData.append("EmployeeDescription", employeeDescription);
      formData.append("Status", 2);

      Job.updateJob(job_id, formData).then((response) => {
        if (response.success) {
          setStatus(2);
          setValue(0);
          dispatch(
            showToast({
              type: "success",
              message: "Job assigned successfully!",
            })
          );
        }
        setUpdateLoading(false);
      });
    }
  };

  return loading ? (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "70vh",
      }}
    >
      <CircularProgress />
    </Box>
  ) : (
    <>
      <Box
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Backdrop sx={{ color: "red", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={updateLoading}>
          <CircularProgress color="primary" />
        </Backdrop>
        <Box>
          <Paper className={classes.paper}>
            <Grid container spacing={2} height="100%">

            {readOnly ? (
              <Grid item xs={12} className={classes.gridItem}>
                <h3 className={classes.detailsHeader}>
                  <b> Employee </b>
                </h3>

                <List sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}>
                  <ListItem alignItems="flex-start" sx={{ pl: 0 }}>
                    <ListItemText primary="Employee" secondary={employee} />
                  </ListItem>

                  <ListItem alignItems="flex-start" sx={{ pl: 0 }}>
                    <ListItemText primary="Employee Description" secondary={employeeDescription} />
                  </ListItem>
                </List>
              </Grid>
            ) : (
              <>
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6} className={classes.gridItem}>
                  <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "space-between", height: "100%" }}>
                    <h3 className={classes.detailsHeader}>
                      <b> Employee </b>
                    </h3>

                    <TextField
                      margin="normal"
                      select
                      label="Select Employee"
                      variant="filled"
                      size="small"
                      fullWidth
                      value={employee}
                      onChange={(e) => setEmployee(e.target.value)}
                      error={errors.employeeId}
                      helperText={errors.employeeId ? "Please select Employee!" : ""}
                      required
                      sx={{ marginBottom: "25px" }}
                    >
                      {employees.map((employee) => (
                        <MenuItem key={employee.User_id} value={employee.User_id}>
                          {employee.FirstName} {employee.LastName}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={6} xl={6} className={classes.gridItem}>
                  <InputLabel sx={{ mt: 1 }} className="inputFormCustomLabel"> Description </InputLabel>
                  <TextField
                    readOnly={readOnly}
                    margin="normal"
                    value={employeeDescription}
                    onChange={(e) => setEmployeeDescription(e.target.value)}
                    fullWidth
                    variant="filled"
                    placeholder="Enter Description Here"
                    hiddenLabel
                    sx={{ mt: 1 }}
                    error={errors.description}
                    helperText={errors.description ? "Please enter Description!" : ""}
                    multiline
                    rows={5}
                    required
                  />
                </Grid>
              </>
            )}
            </Grid>
          </Paper>
        </Box>
      </Box>
      {!readOnly && (
        <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
          <Box sx={{ flex: "1 1 auto" }} />
          <Button
            variant="contained"
            size="small"
            onClick={handleAssignJob}
            style={{
              backgroundColor: "#3a3d4a",
              padding: "5px 20px",
            }}
          >
            Assign
          </Button>
        </Box>
      )}
    </>
  );
};

export default AssignJob;
